export enum BILLING_CYCLES {
    ONE_TIME = 'one_time',
    MONTHLY = 'monthly',
    QUARTERLY = 'quarterly',
    SEMIANNUALLY = 'semiannually',
    YEARLY = 'yearly',
}

export enum BILLING_TIME {
    ANNIVERSARY = 'anniversary',
    REGULAR = 'regular',
    CUSTOM = 'custom',
}

export enum BILLING_STATUS {
    PAST = 'past',
    CURRENT = 'current',
    SCHEDULED = 'scheduled',
}

/*
 * What is measured and how it aggregates now live on a BillableMetric, referenced by the plan item.
 * Sending measurement_type / stateful_billing_strategy / metered_billing_strategy here is a 400.
 */
export type ServicePlanBillingPolicy = {
    id: string;
    created_at: string;
    modified_at: string;
    version_number: number;
    status: BILLING_STATUS;
    valid_from: string;
    billing_cycle: BILLING_CYCLES;
    billing_time: BILLING_TIME;
    valid_to: string | null;
    enable_proration: boolean | null;
};
